import { AmenityCategory } from "@/types/AmenityCategory";
import { useEffect } from "react";
import AmenityList from "../AmenityList";
import Close from "../icons/Close";
import ButtonIcon from "../utils/ButtonIcon";
import Modal from "../utils/Modal";
import "./index.scss";

const AmenityListModal = ({
  amenityCategories,
  onClose,
}: {
  amenityCategories: AmenityCategory[];
  onClose: () => void;
}) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  const amenityCategoryNodes = amenityCategories.map((category) => {
    return (
      <AmenityList
        key={category.name}
        name={category.name}
        amenities={category.amenities}
      />
    );
  });

  return (
    <Modal>
      <div className="component amenity-list-modal">
        <div className="amenity-list-modal-inner-wrapper">
          <div className="modal-header">
            <ButtonIcon onClick={onClose} aria-label="Close">
              <Close />
            </ButtonIcon>
          </div>
          <div className="modal-body">{amenityCategoryNodes}</div>
        </div>
      </div>
    </Modal>
  );
};

export default AmenityListModal;
